import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import { Draggable, Droppable } from "react-beautiful-dnd";
import List from "@material-ui/core/List";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ArticleDraggable from "./ArticleDraggable";
import articlesStore from "../../../store/articles/ArticlesStore";
import EditTextField from "../../EditArticle/EditTextField";
import { updateArticlegroups, updateArticlegroupsTranslations } from "../../../store/articles/ArticlesApi";
import AuthorizationWrapper from "../../AuthorizationWrapper";
import withIntl from "../../../utils/withIntl";
import { Grid } from "@material-ui/core";
import cloudStore from "../../../store/CloudStore";
import { getTranslationValue } from "../../../store/articles/ArticlesHelpers";
import ActionButtonArticlegroup from "../ActionButtons/ActionButtonArticlegroup";

const useStyles = makeStyles((theme) => ({
  accordionSummary: {
    flexFlow: "wrap",
    alignItems: "center",
  },
  details: {
    padding: 0,
  },
  expanded: {
    borderTop: "1px solid lightgrey",
    boxShadow: "none",
    "&$expanded": {
      margin: "0",
      "&:first-child": {
        marginTop: 0,
      },
      "&:last-child": {
        marginBottom: 0,
      },
      "&:before": {
        opacity: 0,
      },
    },
    "&$expanded + &": {
      "&:before": {
        display: "none",
      },
    },
  },
  rootButton: {
    fontSize: 12,
    padding: 2,
    marginRight: "5px",
    margin: 12,
  },
}));

function ArticlegroupDraggable(props) {
  const classes = useStyles();
  const [expandedArticles, setExpandedArticles] = React.useState([]);

  const onArticleExpand = (article) => {
    if (!expandedArticles.includes(article.id)) {
      setExpandedArticles([...expandedArticles, article.id]);
    } else {
      expandedArticles.splice(
        expandedArticles.findIndex((entry) => entry === article.id),
        1
      );
      setExpandedArticles([...expandedArticles]);
    }
  };

  const updateTranslations = (value) => {
    const translationsObject =
      props.articlegroup.translation_id && articlesStore.translations[props.articlegroup.translation_id]
        ? articlesStore.translations[props.articlegroup.translation_id]
        : {};
    return updateArticlegroupsTranslations(
      articlesStore.merchantId,
      [props.articlegroup],
      [{ translation: { [props.currentLanguage]: value } }],
      translationsObject
    ).then(Promise.resolve());
  };

  return (
    <Accordion
      TransitionProps={{ unmountOnExit: true }}
      expanded={props.expandedArticlegroups.includes(props.articlegroup.id)}
      defaultExpanded
      innerRef={props.provided.innerRef}
      {...props.provided.draggableProps}
      onChange={() => props.handleExpansion(props.articlegroup.id)}
      classes={{ root: classes.expanded }}
      square
    >
      <AccordionSummary
        id="panel1a-header"
        classes={{ content: classes.accordionSummary }}
        expandIcon={<ExpandMoreIcon />}
      >
        <Grid container alignItems={"center"}>
          <Grid item container justify={"flex-start"} xs={2} sm={1}>
            {!props.hideDragHandles && (
              <AuthorizationWrapper
                permission={"articlegroup.drag"}
                child={
                  <div
                    {...props.provided.dragHandleProps}
                    style={{ cursor: "move", display: "flex", flexDirection: "column", justifyContent: "center" }}
                  >
                    <DragHandleIcon
                      style={{
                        marginLeft: 0,
                        marginRight: 10,
                      }}
                    />
                  </div>
                }
              />
            )}
          </Grid>
          <Grid item xs={9} sm={4}>
            <EditTextField
              key={props.articlegroup.name}
              helperText={
                isNaN(props.articlegroup.id) &&
                props.intl.formatMessage({ id: "create_articles_to_save_changes_first" })
              }
              fullWidth
              authorizationField={
                "articlegroup.name" +
                (props.currentLanguage === cloudStore.merchant.default_language ? "" : ".other_language")
              }
              label={props.intl.formatMessage({ id: "group_name" })}
              value={getTranslationValue("name", "translation_id", props.currentLanguage, props.articlegroup, "")}
              placeholder={props.articlegroup.name}
              onBlur={(newArticlegroupName, setBeginValue) => {
                if (props.currentLanguage === cloudStore.merchant.default_language) {
                  updateArticlegroups(articlesStore.merchantId, [props.articlegroup], "name", [
                    newArticlegroupName,
                  ]).then(() => setBeginValue(newArticlegroupName));
                } else {
                  updateTranslations(newArticlegroupName).then(() => setBeginValue(newArticlegroupName));
                }
              }}
              variant={"standard"}
            />
          </Grid>
          {props.expandedArticlegroups.some(
            (exandedArticlegroupId) => exandedArticlegroupId === props.articlegroup.id
          ) && (
            <Grid item xs={12} sm={7}>
              <Grid container justify="center">
                <ActionButtonArticlegroup currentLanguage={props.currentLanguage} articlegroup={props.articlegroup} />
              </Grid>
            </Grid>
          )}
        </Grid>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <Droppable type="ARTICLE" droppableId={"droppable-articlegroup-" + props.articlegroup.id}>
          {(provided) => {
            return (
              <List dense style={{ width: "100%" }} innerRef={provided.innerRef} {...provided.droppableProps}>
                {props.articlegroup.getArticles(articlesStore.articles).reduce((articles, article, articleIndex) => {
                  if (article.hide) {
                    return articles;
                  }
                  articles.push(
                    <Draggable
                      type="ARTICLE"
                      draggableId={"draggable-article-" + article.id}
                      index={articleIndex}
                      key={article.id}
                      isDragDisabled={props.hideDragHandles}
                    >
                      {(provided, snapshot) => {
                        return (
                          <ArticleDraggable
                            provided={provided}
                            snapshot={snapshot}
                            articleId={article.id}
                            expanded={expandedArticles.includes(article.id)}
                            onExpand={onArticleExpand}
                            hideDragHandles={props.hideDragHandles}
                            currentLanguage={props.currentLanguage}
                          />
                        );
                      }}
                    </Draggable>
                  );
                  return articles;
                }, [])}
                {provided.placeholder}
              </List>
            );
          }}
        </Droppable>
      </AccordionDetails>
    </Accordion>
  );
}

export default withIntl(ArticlegroupDraggable);
